import { ConnectedCampaignTypeButton } from "../CampaignTypeButton/ConnectedCampaignTypeButton";
import { ConnectedNavigationButton } from "../NavigationButton/ConnectedNavigationButton";

import { getOrganizationToolPartDisplay } from "./getOrganizationToolPartDisplay";
import { useOrganizationApprovalContent } from "./useOrganizationApprovalContent";

import type { AssistantConfig } from "@/features/Assistant/contexts/AssistantConfigContext";

export const ORGANIZATION_ASSISTANT_CONFIG: AssistantConfig = {
  feature: "organization-assistant",
  linkPolicy: { hosts: ["support.zeffy.com"], allowCurrentOrigin: false },
  getToolPartDisplay: getOrganizationToolPartDisplay,
  toolRenderers: {
    "tool-openDashboardPage": ConnectedNavigationButton,
    "tool-recommendCampaignType": ConnectedCampaignTypeButton,
  },
  useApprovalContent: useOrganizationApprovalContent,
};
